import { extendTheme, ThemeConfig } from '@chakra-ui/react';
import { brandColors, lightColors, darkColors } from '../styles/v0/colors';

// 配置 Chakra UI 主题，支持颜色模式
const config: ThemeConfig = {
  initialColorMode: 'system', // 使用系统颜色模式
  useSystemColorMode: true,   // 启用系统颜色模式
};

// 扩展默认 Chakra UI 主题
const chakraTheme = extendTheme({
  config,
  colors: {
    // 添加品牌色
    brand: {
      red: brandColors.red,
      teal: brandColors.teal,
      purple: brandColors.purple,
      orange: brandColors.orange,
    },
    
    // 状态颜色
    status: {
      success: brandColors.success,
      warning: brandColors.warning,
      info: brandColors.info,
      error: brandColors.error,
    },
    
    // 重写部分 Chakra UI 颜色
    gray: {
      50: lightColors.background.tertiary,
      100: lightColors.background.secondary,
      200: lightColors.border.light,
      300: lightColors.border.medium,
      400: lightColors.border.dark,
      500: lightColors.text.tertiary,
      600: lightColors.text.secondary,
      700: lightColors.text.primary,
      800: darkColors.surface.secondary,
      900: darkColors.background.primary,
    },
  },
  
  // 自定义主题变量
  semanticTokens: {
    colors: {
      // 背景颜色
      'bg-primary': {
        default: lightColors.background.primary,
        _dark: darkColors.background.primary,
      },
      'bg-secondary': {
        default: lightColors.background.secondary,
        _dark: darkColors.background.secondary,
      },
      'bg-tertiary': {
        default: lightColors.background.tertiary,
        _dark: darkColors.background.tertiary,
      },
      
      // 表面颜色
      'surface-primary': {
        default: lightColors.surface.primary,
        _dark: darkColors.surface.primary,
      },
      'surface-secondary': {
        default: lightColors.surface.secondary,
        _dark: darkColors.surface.secondary,
      },
      'surface-tertiary': {
        default: lightColors.surface.tertiary,
        _dark: darkColors.surface.tertiary,
      },
      
      // 文本颜色
      'text-primary': {
        default: lightColors.text.primary,
        _dark: darkColors.text.primary,
      },
      'text-secondary': {
        default: lightColors.text.secondary,
        _dark: darkColors.text.secondary,
      },
      'text-tertiary': {
        default: lightColors.text.tertiary,
        _dark: darkColors.text.tertiary,
      },
      
      // 边框颜色
      'border-light': {
        default: lightColors.border.light,
        _dark: darkColors.border.light,
      },
      'border-medium': {
        default: lightColors.border.medium,
        _dark: darkColors.border.medium,
      },
      'border-dark': {
        default: lightColors.border.dark,
        _dark: darkColors.border.dark,
      },
    },
  },
  
  // 组件默认样式
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'medium',
        borderRadius: 'md',
      },
      variants: {
        solid: {
          bg: brandColors.red,
          color: 'white',
          _hover: {
            bg: `${brandColors.red}DD`,
          },
        },
        outline: {
          borderColor: brandColors.red,
          color: {
            default: brandColors.red,
            _dark: 'white',
          },
          _hover: {
            bg: brandColors.red,
            color: 'white',
          },
        },
      },
    },
    Card: {
      baseStyle: {
        container: {
          bg: 'surface-primary',
          borderRadius: 'xl',
          borderWidth: '1px',
          borderColor: 'border-light',
          overflow: 'hidden',
        },
      },
    },
    Input: {
      baseStyle: {
        field: {
          borderRadius: 'md',
        },
      },
      variants: {
        outline: {
          field: {
            borderColor: 'border-light',
            bg: {
              default: 'white',
              _dark: 'surface-secondary'
            },
            _hover: {
              borderColor: 'border-medium',
            },
            _focus: {
              borderColor: brandColors.red,
              boxShadow: `0 0 0 1px ${brandColors.red}`,
            },
          },
        },
      },
    },
  },
  
  // 其他主题设置
  styles: {
    global: {
      body: {
        bg: 'bg-primary',
        color: 'text-primary',
      },
    },
  },
});

export default chakraTheme; 